import { _ as _toConsumableArray } from '../unsorted/toConsumableArray.js';
import { useMemo } from 'react';
import { IMAGE_SIZE_VARIANTS, DEFAULT_IMAGE_SIZE_VARIANT } from '../constants.js';
import { b as getImageSizeMapping, p as pickResponsiveSize, a as pickSizeInLayout } from '../utils/imageHelpers2.js';
import { getStartingSize } from '../utils/styleHelpers.js';
import { useTheme } from './useTheme.js';
import { u as useWindowSizeStore } from '../providers/windowSizeContext/windowSizeContext.js';

function useGetResponsiveImageSizes(size, componentKind) {
  var _useWindowSizeStore = useWindowSizeStore(function (state) {
      return state.width;
    }),
    width = _useWindowSizeStore.state;
  var theme = useTheme();
  var breakpointAsArray = theme.base.breakpointAsArray;
  var startingSize = getStartingSize(size, DEFAULT_IMAGE_SIZE_VARIANT, IMAGE_SIZE_VARIANTS);
  var sizeMapping = getImageSizeMapping(componentKind, theme, true);
  var responsiveSizes = useMemo(function () {
    var defaultSize = pickResponsiveSize(startingSize, sizeMapping);
    if (width === null) return defaultSize;
    if (Array.isArray(size)) {
      var actualResponsiveSizes = _toConsumableArray(size);
      actualResponsiveSizes.shift();
      return actualResponsiveSizes.reduce(function (accum, curr, index) {
        var newAccum = accum;
        if (curr !== null && width >= breakpointAsArray[index]) {
          newAccum = pickResponsiveSize(curr, sizeMapping);
        }
        return newAccum;
      }, defaultSize);
    }
    return /small|medium|large|xLarge/.test(size) ? pickResponsiveSize(size, sizeMapping) : defaultSize;
  }, [startingSize, sizeMapping, width, size, breakpointAsArray]);
  return responsiveSizes;
}
function useGetRelativeImageSizeInLayout(size, componentKind) {
  var _useWindowSizeStore2 = useWindowSizeStore(function (state) {
      return state.width;
    }),
    width = _useWindowSizeStore2.state;
  var theme = useTheme();
  var breakpointAsArray = theme.base.breakpointAsArray;
  var startingSize = getStartingSize(size, DEFAULT_IMAGE_SIZE_VARIANT, IMAGE_SIZE_VARIANTS);
  var sizeMapping = getImageSizeMapping(componentKind, theme, true);
  var relativeImageSizeInLayout = useMemo(function () {
    var defaultSize = pickSizeInLayout(startingSize, sizeMapping);
    if (width === null) return defaultSize;
    if (Array.isArray(size)) {
      var actualResponsiveSizes = _toConsumableArray(size);
      actualResponsiveSizes.shift();
      return actualResponsiveSizes.reduce(function (accum, curr, index) {
        var newAccum = accum;
        if (curr !== null && width >= breakpointAsArray[index]) {
          newAccum = pickSizeInLayout(curr, sizeMapping);
        }
        return newAccum;
      }, defaultSize);
    }
    return /small|medium|large|xLarge/.test(size) ? pickSizeInLayout(size, sizeMapping) : defaultSize;
  }, [startingSize, sizeMapping, width, size, breakpointAsArray]);
  return relativeImageSizeInLayout;
}

export { useGetRelativeImageSizeInLayout, useGetResponsiveImageSizes };
//# sourceMappingURL=responsiveImageSizeHooks.js.map
